
import { useEffect, useState } from 'react';

export default function useIsMobile(breakpointPx: number = 992) {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    (typeof window !== 'undefined' ? window.innerWidth < breakpointPx : false)
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpointPx);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpointPx]);
  return isMobile;
}
